<div class="ts-card">
    <a routerLink="/allocate/allocation-list" class="back-link">&laquo; Back</a>
    <app-loading *ngIf="loading"></app-loading>

    <div *ngIf="!loading && currentTrade">
        <div class="order-info-grid top-box">
            <div class="grid-label-cell">Order information</div>
            <div>Symbol</div>
            <div class="text-right-numeric">Average price</div>
            <div class="text-right-numeric">Quantity</div>
            <div>Order side</div>
            <div>Position side</div>
            <div>{{ currentTrade.symbol }}</div>
            <div class="text-right-numeric">{{ currentTrade.priceCalc |
                currency:'USD':'symbol':'1.2-2' }}</div>
            <div class="text-right-numeric">{{ expectedQuantity }}</div>
            <div>{{ currentTrade.side }}</div>
            <div>{{ currentTrade.posSide }}</div>
        </div>
        <form>
            <app-allocation-progress-actions
                [selectedQuantity]=" selectedQuantity"
                [expectedQuantity]="expectedQuantity"
                (onAllocateClick)="onAllocate()"
                (onResetClick)="onReset()">
            </app-allocation-progress-actions>
        </form>
        <table class="ts-table">
            <thead>
                <tr>
                    <th class="text-right-numeric header-vertical-border">Account</th>
                    <th class="header-vertical-border">User</th>
                    <th class="header-vertical-border">Symbol</th>
                    <th class="header-vertical-border">Long/Short</th>
                    <th class="text-right-numeric header-vertical-border">Price</th>
                    <th class="text-right-numeric header-vertical-border">Quantity</th>
                    <th class="text-right-numeric header-vertical-border">New Quantity</th>
                    <th class="text-right-numeric header-vertical-border">New Price</th>
                    <th class="text-right-numeric header-vertical-border">Qty to Allocate</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let order of accounts">
                    <td class="text-right-numeric">
                        <a routerLink="/account/accountdetail">{{ order.accountId }}</a>
                    </td>
                    <td>{{ order.userNamed }}</td>
                    <td>{{ order.symbol }}</td>
                    <td>{{ order.side }}</td>
                    <td class="text-right-numeric">{{ order.price | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td class="text-right-numeric">{{ order.quantity }}</td>
                    <td class="text-right-numeric">{{ order.newQuantity }}</td>
                    <td class="text-right-numeric">{{ order.newPrice | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td class="text-right-numeric">
                        <input type="number" class="quantity-input" [ngModel]="order.quantityToAllocate"
                            (change)="quantityToAllocateChanged(order, $event)">
                    </td>
                </tr>
            </tbody>
        </table>
        <form>
            <app-allocation-progress-actions
                [selectedQuantity]=" selectedQuantity"
                [expectedQuantity]="expectedQuantity"
                (onAllocateClick)="onAllocate()"
                (onResetClick)="onReset()">
            </app-allocation-progress-actions>
        </form>
    </div>
</div>
